import axios from 'axios'

const ENDPOINTS = {
    'ADD': '/cart/add.js',
    'CART': '/cart.js',
    'CHANGE': '/cart/change.js',
    'PRODUCT': '/products/[REPLACE]/images.js',
    'PRODUCT_IMAGES': '/products/[REPLACE]/images.js',
    'UPDATE': '/cart/update.js'
}

class AjaxAPI {
    static async addItem (payload) {
        let cart = await this.getCart()
        let product = null

        // product = await axios.post(`${ENDPOINTS.ADD}?cache=${this._rand()}`, payload)
        product = await axios.post(`${ENDPOINTS.ADD}`, payload)
        cart = await this.getCart()

        if (cart.status === 200) document.dispatchEvent(new Event('cartItemAdded'))
        // if (cart.status === 200) window.location.replace('/cart')
        if (cart.status === 200) {
            this._cartItemAdded(cart.data)
        }

        return {
            'cart': cart,
            'product': product
        }
    }

    static async getProduct (handle) {
        // let product = await axios.get(`${ENDPOINTS.PRODUCT.replace('[REPLACE]', handle)}?cache=${this._rand()}`)
        let product = await axios.get(`${ENDPOINTS.PRODUCT.replace('[REPLACE]', handle)}`)
        return product
    }

    static async getCartImages (cartItems) {
        const requestArray = []
        const getCartImagesObject = {}

        cartItems.forEach((item) => {
            // requestArray.push(axios.get(`${ENDPOINTS.PRODUCT.replace('[REPLACE]', item.handle)}?cache=${this._rand()}`))
            requestArray.push(axios.get(`${ENDPOINTS.PRODUCT.replace('[REPLACE]', item.handle)}`))
        })

        const responses = await axios.all(requestArray)

        responses.forEach((response) => {
            getCartImagesObject[response.data.handle] = response.data.media
        })

        return getCartImagesObject
    }

    static async changeItem (payload) {
        payload.id = `${payload.id}`
        // let cart = await axios.post(`${ENDPOINTS.CHANGE}?cache=${this._rand()}`, payload)
        let cart = await axios.post(`${ENDPOINTS.CHANGE}`, payload)
        cart.data.line_count = this.getLineCount(cart.data)
        return cart
    }

    static async updateItems (payload) {
        payload = {
            'updates': payload
        }
        // let cart = await axios.post(`${ENDPOINTS.UPDATE}?cache=${this._rand()}`, payload)
        let cart = await axios.post(`${ENDPOINTS.UPDATE}`, payload)
        cart.data.line_count = this.getLineCount(cart.data)
        return cart
    }

    static async getCart () {
        // const cart = await axios.get(`${ENDPOINTS.CART}?cache=${this._rand()}`)
        const cart = await axios.get(`${ENDPOINTS.CART}`)
        return cart
    }

    static async removeItem (id) {
        let payload = {
            'id': `${id}`,
            'quantity': 0
        }
        // let product = await axios.post(`${ENDPOINTS.CHANGE}?cache=${this._rand()}`, payload)
        let product = await axios.post(`${ENDPOINTS.CHANGE}`, payload)
        // let cart = await axios.get(`${ENDPOINTS.CART}?cache=${this._rand()}`)
        let cart = await axios.get(`${ENDPOINTS.CART}`)

        cart.data.line_count = this.getLineCount(cart.data)
        return {
            'cart': cart,
            'product': product
        }
    }

    static getLineCount (cart) {
        return cart.items.length
    }

    static _rand () {
        return Math.floor(100000000 + Math.random() * 900000000)
    }

    static _cartItemAdded (cart) {
        document.body.classList.add('cartItemAdded')

        if (document.querySelector('.cart-product-count') === null) {
            var node = document.createElement('span')
            var textnode = document.createTextNode('0')
            node.classList.add('cart-product-count')
            node.appendChild(textnode)
            document.querySelector('.header__icon--cart').appendChild(node)
        }

        let itemCount = cart.item_count
        cart.items.forEach(item => {
            if (item.handle === 'pnm' || item.handle === 'carb-killa-pick-n-mix') itemCount = itemCount - item.quantity
        })

        document.querySelector('.cart-product-count').innerText = itemCount

        var timer = setTimeout(function () {
            document.body.classList.remove('cartItemAdded')
            clearInterval(timer)
        }, 3000)

        if (!document.querySelector('body').classList.contains('cartItemAddedListening')) {
            document.getElementById('product__added').addEventListener('mouseenter', function () {
                if (document.querySelector('body').classList.contains('cartItemAdded')) {
                    clearTimeout(timer)
                }
            })

            document.getElementById('product__added').addEventListener('mouseleave', function () {
                if (document.querySelector('body').classList.contains('cartItemAdded')) {
                    timer = setTimeout(function () {
                        document.body.classList.remove('cartItemAdded')
                        clearInterval(timer)
                    }, 3000)
                }
            })
        }
        document.body.classList.add('cartItemAddedListening')
    }
}

export default AjaxAPI



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/AjaxAPI.js